import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { takeWhile, switchMap, map, filter } from 'rxjs';
import { AboutModel } from '../models/about-model';
import { UserSettingsService } from '@user-settings/services/user-settings.service';
import { AboutService } from '../services/about.service';
import { SystemConfigurationService } from '@admin/services/system-configuration.service';
import { GeneralInformation } from '@admin/models/system-configuration-model';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';

@Component({
  selector: 'mojo-about',
  templateUrl: './about.component.html'
})
export class AboutComponent implements OnInit, OnDestroy {

  @Input() display: boolean = false;
  @Output() displayChange = new EventEmitter();
  aboutDetails: Observable<AboutModel>;
  appName: Observable<string>;
  isAlive: boolean = true;

  isMojoDashboard: Observable<boolean>;

  mciMode = MojoWellKnownNames.Products.Mci;

  displayVersion: Observable<string>;

  constructor(
    private readonly userSettingsService: UserSettingsService,
    private readonly aboutService: AboutService,
    private readonly systemConfigurationService: SystemConfigurationService) {
    this.initAboutDetails();
  }

  private initAboutDetails() {

    this.displayVersion = this.aboutService.getVersionNumber();

   this.userSettingsService.getCurrentProduct().pipe(
     takeWhile(() => this.isAlive))
     .subscribe((product: string) => {
       if (product) {
         this.aboutService.loadAboutData(product);
       }
     });
  }

  closeAboutDialog() {
    this.display = false;
    this.displayChange.emit(this.display);
  }

  ngOnDestroy() {
    this.isAlive = false;
  }

  ngOnInit() {
    this.aboutDetails = this.aboutService.getAboutDetails();
    const currentProduct = this.userSettingsService.getCurrentProduct();

    this.isMojoDashboard =
      currentProduct.pipe(
        map(product => product === MojoWellKnownNames.Products.MojoDashboard));

    this.appName = currentProduct
      .pipe(filter((product: string) => {
          return product != undefined;
        }),
        switchMap((product: string) => {
          return this.systemConfigurationService.getGeneralInformation(product);
        }),
        map((generalInfo: GeneralInformation) => generalInfo.applicationName));
  }
}
